import { isDateInThePast } from '@lumapps/utils/date/isDateInThePast';

/**
 * Whether an end date fails a "mandatory end date" requirement: it must be set and not already
 * in the past (a past end date counts as missing, since saving/republishing an expired content
 * must set a new one).
 */
export const isEndDateMissing = (endDate?: string | null): boolean => {
    if (!endDate) {
        return true;
    }
    // Fail closed: a malformed date string counts as missing (isDateInThePast would return false
    // for an Invalid Date, since NaN comparisons are always false).
    return Number.isNaN(new Date(endDate).getTime()) || isDateInThePast(endDate);
};
